import { c as _c } from "react/compiler-runtime";
import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';
import { ThemeImage } from '../base/ThemeImage';
import styles from './CreditsWeb.module.scss';
import CreditsDark from './credits-dark.svg';
import { creditsData } from './credits-data';
import CreditsLight from './credits-light.svg';
export function CreditsWeb() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 className="srOnly">Credits</h1>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.imageRoot}><ThemeImage srcLight={CreditsLight} srcDark={CreditsDark} alt="Credits Bild" /></div>;
    t2 = <div className={`heading1 ${styles.titlePrimary}`}>BR24.de</div>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SingleColumnLayout className="body3" contentClassName={styles.content}>{t0}{t1}{t2}<section className={styles.section}><p>{creditsData.description}</p></section>{creditsData.sections.map(_temp3)}</SingleColumnLayout>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp3(section, sectionIndex) {
  return <section key={sectionIndex} className={styles.section}><h2 className={styles.titleSecondary}>{section.title}</h2>{section.roles.filter(_temp).map(_temp2)}</section>;
}
function _temp2(role_0, roleIndex) {
  return <section key={roleIndex} className={styles.section}>{role_0.title && <h3 className={styles.titleTertiary}>{role_0.title}</h3>}<p>{role_0.people.join(", ")}</p></section>;
}
function _temp(role) {
  return role.people.length > 0;
}